import { getStateWithOnlyOneLevel } from '../../utils/StateSelectorHelper';

function getBannersState(state) {
  return getStateWithOnlyOneLevel(state, 'banners');
}

export const bannersActive = (state) =>
  getBannersState(state).get('bannersActive');
